import { render } from "./playedSoccerSelector.vue?vue&type=template&id=6b94fae3&ts=true"
import script from "./playedSoccerSelector.vue?vue&type=script&lang=ts"
export * from "./playedSoccerSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__